import { render } from "./fsRaceSignCheck.vue?vue&type=template&id=b557542a&scoped=true"
import script from "./fsRaceSignCheck.vue?vue&type=script&lang=js"
export * from "./fsRaceSignCheck.vue?vue&type=script&lang=js"

import "./fsRaceSignCheck.vue?vue&type=style&index=0&id=b557542a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b557542a"]])

export default __exports__